/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { PtwErrorId } from './PtwErrorId';
import {
    PtwErrorIdFromJSON,
    PtwErrorIdFromJSONTyped,
    PtwErrorIdToJSON,
} from './PtwErrorId';

/**
 * 
 * @export
 * @interface AnalysisResultFault
 */
export interface AnalysisResultFault {
    /**
     * 
     * @type {Array<PtwErrorId>}
     * @memberof AnalysisResultFault
     */
    errorIds?: Array<PtwErrorId> | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultFault
     */
    message?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AnalysisResultFault
     */
    $type?: AnalysisResultFaultTypeEnum;
}


/**
 * @export
 */
export const AnalysisResultFaultTypeEnum = {
    PtwPtw100BeamConstancyCheckCoreMeasurementEntitiesAnalysisResultFaultPtwPtw100BeamConstancyCheckCore: 'Ptw.Ptw100.BeamConstancyCheck.Core.Measurement.Entities.AnalysisResultFault, Ptw.Ptw100.BeamConstancyCheck.Core'
} as const;
export type AnalysisResultFaultTypeEnum = typeof AnalysisResultFaultTypeEnum[keyof typeof AnalysisResultFaultTypeEnum];



/**
 * Check if a given object implements the AnalysisResultFault interface.
 */
export function instanceOfAnalysisResultFault(value?: unknown): value is AnalysisResultFault {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(AnalysisResultFaultTypeEnum)[0];
}

export function AnalysisResultFaultFromJSON(json: any): AnalysisResultFault {
    return AnalysisResultFaultFromJSONTyped(json, false);
}

export function AnalysisResultFaultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AnalysisResultFault {
    if (json == null) {
        return json;
    }
    return {
        
        'errorIds': json['errorIds'] == null ? undefined : ((json['errorIds'] as Array<any>).map(PtwErrorIdFromJSON)),
        'message': json['message'] == null ? undefined : json['message'],
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function AnalysisResultFaultToJSON(value?: AnalysisResultFault | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'errorIds': value['errorIds'] == null ? undefined : ((value['errorIds'] as Array<any>).map(PtwErrorIdToJSON)),
        'message': value['message'],
        '$type': value['$type'],
    });
}

